import { firebasePrefix, getOnce } from '../lib/firebase'
import { toPlace, type Place } from '../types/display'

export function placePath(placeId: string): string {
  return `${firebasePrefix}/master/place/${placeId}/fields`
}

export async function fetchPlace(placeId: string): Promise<Place | null> {
  const value = await getOnce<unknown>(placePath(placeId))
  return toPlace(value)
}
